export enum EUnavailableReason {
  /** Заблокировано администрацией */
  deniedBySanctions = 'deniedBySanctions',
  /** Нет фотографий */
  noPhotos = 'noPhotos',
  /** Доступно после окончания периода публикации Премиум */
  onlyAfterPremiumServiceExpiration = 'onlyAfterPremiumServiceExpiration',
  /** Не является участником акции */
  onlyInAction = 'onlyInAction',
  /** Не выполнены условия, необходимые для размещения Топ-объявлений */
  top3ServiceDenied = 'top3ServiceDenied',
}

export enum EPublicationType {
  /** Ограниченная по дням публикация, подневная тарификация */
  dailyLimited = 'dailyLimited',
  /** Бессрочная публикация, подневная тарификация */
  dailyTermless = 'dailyTermless',
  /** Тарификация за весь период */
  periodical = 'periodical',
}

export enum EServiceType {
  /** Спрос */
  demand = 'demand',
  /** Бесплатная публикация */
  free = 'free',
  /** Платная публикация */
  paid = 'paid',
  /** Премиум публикация */
  premium = 'premium',
  /** ckage: Пакет заявок */
  demandPackage = 'demandPackage',
  /** Колтрекинг */
  calltracking = 'calltracking',
  /** Аукцион */
  auction = 'auction',
  /** Топ */
  top3 = 'top3',
  /** Выделение цветом */
  highlight = 'highlight',
  /** Выделение цветом */
  servicePackage = 'servicePackage',
}
